import React from "react";
import { thousandFormatter } from "~/utils/formatter";
import { useTranslation } from "react-i18next";
import { INVEST_STEP } from "~/constant/ApplyFormConstant";

const InvestInfo = ({ portfolio }) => {
	const { t } = useTranslation();

	return (
		<li>
			<div className="title-group">
				<h3 className="basic-info-title">
					{t("pages.portfolio.PortfolioView.components.InvestInfo.info")}
				</h3>
			</div>
			<ul className="basic-info-content">
				<li>
					{t("pages.portfolio.PortfolioView.components.InvestInfo.onGoing")} :{" "}
					<b>{portfolio.investStatus}</b>
				</li>
				{portfolio.investStatus !== "계획없음" && (
					<>
						<li>
							{t("pages.portfolio.PortfolioView.components.InvestInfo.aimRound")} :{" "}
							{INVEST_STEP[portfolio.round - 1]}
						</li>
						<li>
							{t("pages.portfolio.PortfolioView.components.InvestInfo.fixedValue")} :{" "}
							{thousandFormatter(portfolio.comValue) || 0}
							{t("pages.portfolio.PortfolioView.components.InvestInfo.hMillion")}
						</li>
						<li>
							{t("pages.portfolio.PortfolioView.components.InvestInfo.aimInvest")} :{" "}
							{thousandFormatter(portfolio.target) || 0}
							{t("pages.portfolio.PortfolioView.components.InvestInfo.hMillion")}
						</li>
					</>
				)}
			</ul>
		</li>
	);
};

export default InvestInfo;
